import { render } from "./NotFound.vue?vue&type=template&id=25523188&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=25523188&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25523188"]])

export default __exports__